import { BadgeVariant } from '../../helpers/mapBadgeVariant';

export const isListingImage = (image: ListingImage | AerialImage): image is ListingImage =>
  'webpUri' in image || 'jpgUri' in image;

export interface ListingImage {
  alt: string;
  caption?: string | null;
  jpgUri: string;
  webpUri: string;
}

export interface AerialImage {
  alt: string;
  caption?: string | null;
  uri: string;
}

export interface Badge {
  text: string;
  variant: BadgeVariant;
}

export interface TitleWithSourceLevel {
  display?: string;
  sourceLevel: number;
}
